<template>
	<div class="container2">
		<div class="main-all">
		<div class="main-img2">
			<!-- <img src="../../assets/jiudianbao.jpg"/> -->
			
			<el-carousel :interval="5000" arrow="always" class="main-img-all">
				<el-carousel-item v-for="(item,index) in imgList" :key="index" class="main-img-lb">
					<el-image class="main-img1"
						:src="item.img" ></el-image>
				</el-carousel-item>
			</el-carousel>
		</div>
		</div>
		<div class="fotter">
			<div class="fotter1">
			<!-- 	<div class="fotter1-text size-28 fbold">
					<span class="color-text3 ">能量工厂</span>
					<span>官网-深圳市乐园互联网科技有限公司</span>
				</div> -->
				<div class="fotter1-text2">
					<!-- <div class="fotter1-text2-1 fbold-24">
						<span>能量工厂-全球十大</span>
						<span class="color-text">共享充电线</span>
						<span>品牌之一，</span>
						<span class="color-text2">能量工厂3c认证</span>
					</div> -->
					<div class="fotter1-text2-2">
						<div class="fotter1-text2-2-left color-text3 fbold size-28">客房服务管家</div>
						<span class="fbold-24">1、设备采用ABS防火阻燃材质，外观小巧美观。台历本大小，插入房卡后自动播放迎宾语，自带引流。</span>
						
					</div>
					<div class="fotter1-text2-2 fbold-24">2、搭载独有的全智能一键云更新系统，后续功能免费更新</div>
					<div class="fotter1-text2-2 fbold-24">3、提供人员招聘、团队组建、销售技巧、会销指导等全套资料，你只需要轻松赚钱。</div>
					<div class="fotter1-text2-2 fbold-24">4、使用教程、部署指导、升级指导、技术指导等。</div>
					<div class="fotter1-text2-2">
						<div class="fotter1-text2-2-left color-text3 fbold size-28">四大优势</div>
						<span class="fbold-24">1、即买即用：多款小程序已开发好，可以立即上线</span>
					</div>
					<div class="fotter1-text2-2 fbold-24">2、一键授权：无需过多配置，一键绑定傻瓜化操作</div>
					<div class="fotter1-text2-2 fbold-24">3、深入行业：面向餐饮、酒店、娱乐等行业深度开发</div>
					<div class="fotter1-text2-2 fbold-24">4、功能丰富：电商、O2O、行业类各种开发好的小程序</div>
					<div class="fotter1-text2-4 fbold-24">
						<span>代理加盟咨询老板：刘总 </span>
						<span class="color-text3">15899889999</span>
						<span> 微信同号</span>
					</div>
					<div class=" fbold-24">
						<span>公司总部：广东省深圳市宝安区新桥街道上星社区上星路万科星城星宸大厦第3栋6楼整层.</span>
					</div>
				</div>
			</div>
			<div class="fotter2">
				<!-- <el-image src="../../assets/img/cable/guanfang.jpg"></el-image> -->
				<!-- <img src="../../assets/img/cable/guanfang.jpg"/> -->
				<!-- <img src="../../assets/img/product/erweima.png"/> -->
				<img src="../../assets/jiudianbao.jpg"/>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				imgList:[
					
					{
						id:3,
						// img:require('../../assets/jiudianbao.jpg')
						img:require('../../assets/img/main/9.jpeg')
					},
				],
			}
		}
	}
</script>

<style scoped>
	.container2 {
		background: #ffffff;
		padding-bottom: 20px;
	}
	.main-img-all {
		width: 100%;
	}
	
	.main-img-lb {
		/* height: 420px; */
	}
	/deep/ .el-image__inner{
		height: auto !important;
	}
	
	.main-img1 {
		width: 100%;
		height: 570px;
	}
	
	::v-deep .el-carousel__container {
		min-height: 570px;
	}
	.fotter{
		margin-top: 5%;
		padding-left: 12%;
		padding-right: 12%;
		display: flex;
	}
	.fotter1{
		width: 50%;
		text-align: left;
		line-height: 30px;
	}
	.fotter2{
		width: 40%;
	}
	.fotter2 img{
		width: 70%;
	}
	.fotter1-text{
		font-size: 26px;
		color: rgb(51, 51, 51);
	}
	.fotter1-text2{
		margin-top: 3%;
		line-height: 2.8;
	}
	.fotter1-text2-4{
		margin-top: 3%;
	}
	.fbold{
		font-weight: bold;
	}
	.size-28{
		font-size: 26px;
	}
	.fbold-24{
		font-size: 20px;
		font-weight: bold;
	}
	.main-all{
		background: #4080e2;
	}
	.main-img2{
	/* 	width: 320px;
		margin: auto; */
		
		width: 100%;
		margin: auto;
	}
	.main-img2 img{
		width: 100%;
		height: 100%;
	}
</style>